import { db } from '../firebase';
import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';

export const fetchUserDetails = async (userId) => {
  let userDetails = {
    streakCount: 0,
    courseBookings: [],
    totalTokens: 0,
    lastPracticeLessonId: null,
    subscriptionStatus: false,
  };

  // Fetch course bookings
  const bookingsSnap = await getDocs(query(collection(db, 'coursebookings'), where("userid", "==", userId)));
  userDetails.courseBookings = bookingsSnap.docs.map(doc => doc.data());

  // Fetch last practice lesson ID
  const lastLessonQuery = query(
    collection(db, "userpracticesessions"),
    where("userid", "==", userId),
    orderBy("date", "desc"),
    limit(1)
  );
  const lastLessonSnap = await getDocs(lastLessonQuery);
  if (!lastLessonSnap.empty) {
    userDetails.lastPracticeLessonId = lastLessonSnap.docs[0].data().lessonid;
  }

  // ✅ Fetch total streak count from userstreaktotal collection
  const streakQuery = query(
    collection(db, "userstreaktotal"),
    where("userid", "==", userId),
    orderBy("date", "desc"),
    limit(1)
  );
  const streakSnap = await getDocs(streakQuery);
  if (!streakSnap.empty) {
    userDetails.streakCount = streakSnap.docs[0].data().totalstreakcount;
  }

  // Fetch total tokens
  const tokensQuery = query(
    collection(db, "usertotaltokens"),
    where("userid", "==", userId),
    orderBy("date", "desc"),
    limit(1)
  );
  const tokensSnap = await getDocs(tokensQuery);
  if (!tokensSnap.empty) {
    userDetails.totalTokens = tokensSnap.docs[0].data().totaltokens;
  }

  // Fetch subscription status
  const subQuery = query(
    collection(db, "subscriptions"),
    where("userid", "==", userId),
    limit(1)
  );
  const subSnap = await getDocs(subQuery);
  userDetails.subscriptionStatus = subSnap.empty ? false : subSnap.docs[0].data().isactive === "1";

  return userDetails;
};
